import { libraryKindFromMemberInput, stripContentIdPrefix } from "@healthos/shared";
/** The reset a deep link's `content` and `kind` params name, or null when they name none. */
export function notifiedResetId(content, kind) {
    if (!content || libraryKindFromMemberInput(kind) !== "Reset")
        return null;
    return stripContentIdPrefix(content).trim() || null;
}
/** Spent once the fetch settles, whatever it found, so a link never fires again on a later close. */
export function notifiedResetDecision(input) {
    if (!input.resetId || input.isPending)
        return { open: null, spend: false };
    const videoUrl = input.article?.videoUrl?.trim();
    if (!videoUrl || input.playerOpen)
        return { open: null, spend: true };
    return {
        open: {
            title: input.article?.title?.trim() || "Your reset",
            description: input.article?.summary ?? "",
            duration: input.article?.durationSeconds ?? 0,
            videoUrl,
            kind: input.article?.contentType === "Guide" ? "Guide" : "Reset",
        },
        spend: true,
    };
}
//# sourceMappingURL=notified-reset.js.map